import type { AnalyticsRenderInput } from "./analytics-render-input";

/**
 * Render an analytics query result to JSON text: a pretty-printed array of row
 * objects, each keyed by column name in `fields` order. Values are kept RAW (a
 * number stays a number, a boolean a boolean, null stays null) — that is what a
 * machine consumer of the JSON expects, unlike the stringified CSV/XLSX cells.
 * Missing cells are emitted as `null` so every object has the same shape. The
 * result set is already materialised (executor caps at 1000 rows), so this is a
 * simple synchronous build.
 */
export function analyticsResultToJsonText(input: AnalyticsRenderInput): string {
  const columns = input.fields.map((f) => f.name);
  const objects = input.rows.map((row) => {
    const obj: Record<string, unknown> = {};
    for (const name of columns) {
      obj[name] = row[name] ?? null;
    }
    return obj;
  });
  return `${JSON.stringify(objects, null, 2)}\n`;
}
